import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import { exitReducer } from './exitReducer';
import { navigationReducer } from './navigationReducer';
import { configReducer } from './configReducer';
import { errorReducer } from './errorReducer';
import { loanValuesReducer } from './loanValuesReducer';
import { caseDetailsReducer } from './caseDetailsReducer';
import { customerReducer } from './customerReducer';
import { loaderReducer } from './loaderReducer';
import { offerReducer } from './offerReducer';
import { calculatorReducer } from './calculatorReducer';
import { userInformationReducer } from './userInformationReducer';
import { accountReducer } from './accountReducer';
import { screenShotReducer } from './screenShotReducer';
import { debtConsolidationReducer } from './debtConsolidationReducer';
import { userSessionReducer } from './userSessionReducer';

export function rootReducer(history) {
  return combineReducers({
    form: formReducer,
    navigation: navigationReducer,
    config: configReducer,
    error: errorReducer,
    loanValues: loanValuesReducer,
    caseDetails: caseDetailsReducer,
    customer: customerReducer,
    calculator: calculatorReducer,
    loader: loaderReducer,
    offer: offerReducer,
    user: userInformationReducer,
    account: accountReducer,
    screenShot: screenShotReducer,
    debtConsolidation: debtConsolidationReducer,
    router: connectRouter(history),
    exitModalOpen: exitReducer,
    userSession: userSessionReducer
  });
}
